<template>
  <div class="s-company-badge s-company-badge--new-pro">
    <SCompanyBadgeStyles />
    {{ tr("client.company_card.badges_new_pro") }}
  </div>
</template>

<script setup lang="ts">
import { useI18nCompanyCard } from "@solvari/translations";

import SCompanyBadgeStyles from "./SCompanyBadgeStyles.vue";

const { tr } = useI18nCompanyCard();
</script>
